<app-image-modal></app-image-modal>
<router-outlet></router-outlet>
<app-copyright></app-copyright>